<template>
  <div>
    <!-- <tab :currentIndex="currentIndex" @changeIndex="changeIndex"/> -->
    <guideRegister v-if="currentIndex === 0"/>
    <companyRegister v-else/>
  </div>
</template>

<script>
import guideRegister from '@/components/register/guideRegister';
import companyRegister from '@/components/register/companyRegister';
import tab from '@/components/register/common/tab';
export default {
  name: "register",
  data(){
    return {
      currentIndex: 0
    }
  },
  methods: {
    changeIndex(index){
      this.currentIndex = index;
    }
  },
  components: {
    guideRegister,
    tab,
    companyRegister
  }
};
</script>
